/* eslint-disable import/prefer-default-export */
export const getListOfGroupsMixin = {
  methods: {
    getListOfGroups(row) {
      if (!row.groupIds || !row.groupNames) return [];
      const groupIdArray = row.groupIds.split(',');
      const groupNameArray = row.groupNames.split(',');
      const returnArray = [];
      for (let i = 0; i < groupIdArray.length; i++) {
        returnArray.push({
          id: groupIdArray[i],
          name: groupNameArray[i]
        });
      }
      return returnArray;
    }
  }
}
